// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import {hasAccess} from '../../services/security';

export const secure = (module, feature) =>
    WrappedComponent => {

        const SecurityWrappedComponent = (props, context) =>
            hasAccess(context.security, module, feature) ?
                <WrappedComponent{...props}/> : null;

        SecurityWrappedComponent.WrappedComponent = WrappedComponent;
        SecurityWrappedComponent.contextTypes = {
            security: PropTypes.instanceOf(Security).isRequired
        };

        return SecurityWrappedComponent;

    };




// WEBPACK FOOTER //
// ./src/shared/components/security-wrapper/secure.js